import type { PlatformHint } from '../../api/types'

/** Tabs of the detail page (``?bereich=``). */
export type TenantArea = 'stammdaten' | 'mitglieder' | 'funktionen'

/** Address of the detail page of a municipality (by its slug, readable and unchangeable), or one of its tabs. */
export const tenantPath = (slug: string, area?: TenantArea) =>
  `/plattform/kommunen/${slug}${area ? `?bereich=${area}` : ''}`

const HINT_AREA: Partial<Record<PlatformHint, TenantArea>> = {
  NO_ADMIN: 'mitglieder',
  INVITATIONS_PENDING: 'mitglieder',
  BODY_TYPE_MISSING: 'stammdaten',
}

/**
 * Where a hint is resolved: a tab of the detail page, or – for a municipality without measures or
 * changes – the municipality itself, to see where it stands.
 */
export function hintTarget(hint: PlatformHint, slug: string): { to: string } | { open: true } {
  const area = HINT_AREA[hint]
  return area ? { to: tenantPath(slug, area) } : { open: true }
}
